export default __webpack_public_path__ + "static/home-header-mobile-86523c5b0cd9aa488ac12f5aefab9b7f.jpg";